import { render } from "./rule.vue?vue&type=template&id=baecefce&scoped=true"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"

import "./rule.vue?vue&type=style&index=0&id=baecefce&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baecefce"]])

export default __exports__